const Common = () => {
    const hues = [180, 200, 220, 240, 260]; // cooler hues
    const hue = hues[Math.floor(Math.random() * hues.length)];
    const sat = 30 + Math.random() * 10; // 30-40% saturation for a soft tone
    const light = 80 + Math.random() * 10; // 80-90% lightness
    return `hsl(${hue}, ${sat}%, ${light}%)`;
};


// const Common = () => {
//     return 
//     // "hsl(170, 60%, 40%); "; // nice soft blue
// };


export default Common